import type { IconData } from '@stacksjs/iconify-core'

export const archiveF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M17 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1zm1 2v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7zM8 14a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default archiveF
